import React from 'react';
import { Button } from '@applyboard/crystal-ui';
import { Field } from '@applyboard/ui-components';
import { PreferencesContainer } from "../../Layout/PreferencesContainer";
import { CheckboxListField } from "../../CheckboxListField";
import { Layout } from "../../Layout";
export var Content = function Content(_ref) {
  var options = _ref.options,
    noBackButton = _ref.noBackButton,
    skipSubmit = _ref.skipSubmit;
  var skipButton = /*#__PURE__*/React.createElement(Button, {
    "aria-label": "",
    emphasis: "highlighted",
    intent: "secondary",
    size: "lg",
    onClick: skipSubmit,
    width: "fill",
    type: "button"
  }, "Skip");
  return /*#__PURE__*/React.createElement(Layout, {
    noBackButton: noBackButton
  }, /*#__PURE__*/React.createElement(PreferencesContainer, {
    skipButton: skipButton
  }, /*#__PURE__*/React.createElement(Field, {
    as: CheckboxListField,
    name: "countries",
    label: "Which countries do you want to study in?",
    options: options,
    required: "Please select at least one option."
  })));
};